(function() {
  // Temporary redirect for consolidated Cloak Shell pages
  const currentPath = window.location.pathname;
  const newUrl = '/products/cloak-shells';

  // Match patterns: /products/cloak-shell-for-* or /products/cloak-shells-for-*
  const redirectPatterns = [
    /^\/products\/cloak-shells?-for-.+$/i
  ];

  // Check if current URL matches any redirect pattern
  const shouldRedirect = redirectPatterns.some(pattern => pattern.test(currentPath));

  if (shouldRedirect && currentPath !== newUrl) {
    window.location.replace(newUrl);
  }
})();
